import { ClinicalAssessmentTypes } from '@sondermind/utilities/models-assessments-monolith';
import { AssessmentStatus, IAssessmentAssignment } from '@sondermind/utilities/models-assessments';

export const CREATE_ASSIGNMENTS_RESPONSE: IAssessmentAssignment[] = [
  {
    _id: '60a1b2c3d4e5f6g7h8i9j0k3',
    assessmentId: '60a1b2c3d4e5f6g7h8i9j0k1',
    assessmentType: ClinicalAssessmentTypes.AUDIT_C,
    assignedByProviderId: 2345,
    clientId: 12345,
    clinicallyRelevantAt: new Date('2023-06-15T10:30:00.000Z'),
    clinicallyRelevantUntil: new Date('2023-07-15T10:30:00.000Z'),
    completedByProviderId: 2345,
    createdAt: new Date('2023-06-15T10:30:00.000Z'),
    currentQuestionIndex: 0,
    lastUpdatedAt: new Date('2023-06-15T10:30:00.000Z'),
    manuallySent: true,
    status: AssessmentStatus.ASSIGNED,
  }
];
